(() => {
  const selector = "[data-klaviyo-footer-form]";
  const defaultError = "We couldn't sign you up. Please try again.";
  const invalidEmailError = "Please enter a valid email address.";

  const setError = (form, message) => {
    const error = form.querySelector(".input-label__error");

    if (error) {
      error.textContent = message;
    }

    form.classList.add("error");
    form.classList.remove("success");
  };

  const clearError = (form) => {
    const error = form.querySelector(".input-label__error");

    if (error) {
      error.textContent = "";
    }

    form.classList.remove("error");
  };

  const setSubmitting = (form, isSubmitting) => {
    const button = form.querySelector('button[type="submit"]');

    form.dataset.submitting = isSubmitting ? "true" : "false";

    if (button) {
      button.disabled = isSubmitting;
    }
  };

  const buildPayload = (email, listId, source) => ({
    data: {
      type: "subscription",
      attributes: {
        custom_source: source,
        profile: {
          data: {
            type: "profile",
            attributes: {
              email,
              subscriptions: {
                email: {
                  marketing: {
                    consent: "SUBSCRIBED",
                  },
                },
              },
            },
          },
        },
      },
      relationships: {
        list: {
          data: {
            type: "list",
            id: listId,
          },
        },
      },
    },
  });

  const handleSuccess = (form) => {
    const fields = form.querySelectorAll("input, button");
    const inputWrapper = form.querySelector(".input__wrapper");

    clearError(form);
    form.classList.add("success");
    form.classList.remove("error");

    fields.forEach((field) => {
      field.disabled = true;
    });

    if (inputWrapper) {
      inputWrapper.hidden = true;
    }
  };

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest(selector);

    if (!form) {
      return;
    }

    event.preventDefault();

    if (form.dataset.submitting === "true") {
      return;
    }

    const emailInput = form.querySelector('input[name="email"]');
    const email = emailInput ? emailInput.value.trim() : "";
    const listId = form.dataset.listId;
    const companyId = form.dataset.companyId;
    const source = form.dataset.source || "Shopify footer newsletter";

    clearError(form);

    if (emailInput) {
      emailInput.value = email;
    }

    if (!emailInput || !emailInput.checkValidity()) {
      setError(form, invalidEmailError);
      emailInput?.focus();
      return;
    }

    if (!listId || !companyId) {
      setError(form, defaultError);
      return;
    }

    setSubmitting(form, true);

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            revision: "2026-04-15",
          },
          body: JSON.stringify(buildPayload(email, listId, source)),
        },
      );

      if (response.status !== 202) {
        throw new Error(`Klaviyo subscription failed with status ${response.status}`);
      }

      handleSuccess(form);
    } catch (error) {
      setError(form, defaultError);
      setSubmitting(form, false);
    }
  });
})();
